import type { ScheduledActionAPI } from '../utils/types';

export function isOnlineOrIdle(
  api: Pick<ScheduledActionAPI, 'getPresence'>,
): boolean {
  return api.getPresence() !== 'offline';
}
